import { Dimensions } from '~/jobiqo/lib/analytics';
import { User } from '~/jobiqo/models/user';
import { SearchApiJobResult } from '~/jobiqo/types/types';
import { Facet } from '~/jobiqo/models/search';

/**
 * Returns the custom dimensions for a given job search.
 *
 * Can be used to add custom dimensions to the analytics event for a job search.
 *
 * @param {User | null} user
 *   The current user.
 * @param {SearchApiJobResult} jobs
 *   Job search API result.
 * @param {string} title
 *   Search title.
 * @param {Facet[]} selectedFacets
 *   Selected facets on the job search page.
 * @param {string} location
 *   Job search location.
 * @param {string} [searchQuery]
 *   The search query.
 * @returns {Dimensions}
 *   The custom dimensions object for this job search.
 */
export const getCustomJobSearchDimensions = (
  user: User | null = null,
  jobs: SearchApiJobResult,
  title: string,
  selectedFacets: Facet[],
  location: string,
  searchQuery?: string,
): Dimensions => {
  return {};
};
